// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"df03d7fc","238":"9cd145ef","239":"456668c6","455":"c58a777a","488":"2b44b2b1"}[chunkId] + ".chunk.js";
};